import { useState, useEffect, useRef, FormEvent } from 'react';

interface ChatInputProps {
  onSubmit: (question: string) => void;
  disabled?: boolean;
}

/** Text input with submit button for asking questions (FR-005). */
export default function ChatInput({ onSubmit, disabled }: ChatInputProps) {
  const [text, setText] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  // Refocus input when response arrives (disabled transitions from true to false)
  useEffect(() => {
    if (!disabled) {
      inputRef.current?.focus();
    }
  }, [disabled]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const trimmed = text.trim();
    if (!trimmed || disabled) return;
    onSubmit(trimmed);
    setText('');
  };

  return (
    <form onSubmit={handleSubmit} className="chat-input-bar">
      <input
        ref={inputRef}
        type="text"
        value={text}
        onChange={e => setText(e.target.value)}
        placeholder="Ask about DSS status, phases, decisions..."
        disabled={disabled}
        className="chat-input"
      />
      <button type="submit" disabled={disabled || !text.trim()} className="chat-submit">
        {disabled ? 'Thinking...' : 'Ask'}
      </button>
    </form>
  );
}
